module.exports = __webpack_public_path__ + "684c8202b9c0144d432562980a96f3b2.png";